"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
exports.__esModule = true;
var React = require("react");
var react_1 = require("react");
var useFetchSituationOptions_1 = require("../../../hooks/useFetchSituationOptions");
var SituationSelectModal_1 = require("../SituationSelectModal");
var querystring = require("querystring");
var SituationSelector_1 = require("./SituationSelector");
var presentSearchHelper_1 = require("../presentSearchHelper");
var styled_components_1 = require("styled-components");
exports.SimpleForm = function () {
    var _a = react_1.useState(false), isInit = _a[0], setIsInit = _a[1];
    var _b = react_1.useState(""), presentee = _b[0], setPresentee = _b[1];
    var _c = react_1.useState(""), age = _c[0], setAge = _c[1];
    var _d = react_1.useState(""), occasion = _d[0], setOccasion = _d[1];
    if (!isInit) {
        var parsed = querystring.parse(window.location.search.slice(1));
        if (parsed.presentee) {
            setPresentee(parsed.presentee);
        }
        if (parsed.age) {
            setAge(parsed.age);
        }
        if (parsed.occasion) {
            setOccasion(parsed.occasion);
        }
        setIsInit(true);
    }
    var _e = useFetchSituationOptions_1.useFetchSituationOptions(SituationSelectModal_1.ModalState.Closed, presentee, age, occasion), situationOptions = _e[0], isSuccess = _e[1], error = _e[2];
    if (!situationOptions) {
        return React.createElement(StyledSimpleForm, null);
    }
    return (React.createElement(StyledSimpleForm, null,
        React.createElement(SituationSelector_1.SituationSelector, { options: situationOptions.presenteeOptions.options, selected: presentee, label: "\u8D08\u308B\u76F8\u624B\u306F\uFF1F", onChange: function (event) {
                setPresentee(event.target.value);
                setAge("");
            } }),
        React.createElement(SituationSelector_1.SituationSelector, { options: situationOptions.ageOptions.options, selected: age, label: "\u5E74\u4EE3\u306F\uFF1F", onChange: function (event) {
                setAge(event.target.value);
            } }),
        React.createElement(SituationSelector_1.SituationSelector, { options: situationOptions.occasionOptions.option_groups, selected: occasion, label: "\u76EE\u7684\u306F\uFF1F", onChange: function (event) {
                setOccasion(event.target.value);
            } }),
        React.createElement(StyledSearchLink, { href: presentSearchHelper_1.getSearchUrl(presentee, age, occasion) }, "\u3053\u306E\u6761\u4EF6\u3067\u63A2\u3059")));
};
var StyledSimpleForm = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  box-sizing: border-box;\n  height: 260px;\n"], ["\n  position: relative;\n  box-sizing: border-box;\n  height: 260px;\n"])));
var StyledSearchLink = styled_components_1["default"].a(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: block;\n  box-sizing: border-box;\n  width: 100%;\n  margin-top: 12px;\n  padding: 8px;\n  text-align: center;\n  font-size: 14px;\n  border: 1px solid #f65c10;\n  border-radius: 4px;\n  &:link,\n  :visited {\n    color: #f65c10;\n    text-decoration: none;\n  }\n  :hover {\n    opacity: 0.7;\n  }\n  background-color: #fff;\n"], ["\n  display: block;\n  box-sizing: border-box;\n  width: 100%;\n  margin-top: 12px;\n  padding: 8px;\n  text-align: center;\n  font-size: 14px;\n  border: 1px solid #f65c10;\n  border-radius: 4px;\n  &:link,\n  :visited {\n    color: #f65c10;\n    text-decoration: none;\n  }\n  :hover {\n    opacity: 0.7;\n  }\n  background-color: #fff;\n"])));
var templateObject_1, templateObject_2;
